var path = 'src/app/patients/pkd/liver-transplants.html';
var html = "<h1 class=page-header>Liver Transplants</h1> <div liver-transplants-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/pkd/liver-transplants.html
 ** module id = 511
 ** module chunks = 0
 **/